import { createSlice } from "@reduxjs/toolkit";

export const seasonsSlice = createSlice({
    name: "seasons",
    initialState: {
        seasons: [],
        seasonToCheck: null,
        latestGames: [],
        nextGames: [],
    },
    reducers: {
        updateMetadata: (state, action) => {
            state.seasons = action.payload.seasons ?? state.seasons;
            state.seasonToCheck = action.payload.seasonToCheck ?? state.seasonToCheck;
            state.latestGames = action.payload.latestGames ?? state.latestGames;
            state.nextGames = action.payload.nextGames ?? state.nextGames;
        },
        clearMetadata: state => {
            state.seasons = [];
            state.seasonToCheck = null;
            state.latestGames = [];
            state.nextGames = [];
        },
    }
});

// Action creators are generated for each case reducer function
export const { updateMetadata, clearMetadata } = seasonsSlice.actions
export default seasonsSlice.reducer;
